import React, { ReactElement } from 'react';
import style from './index.module.css';

export interface ImproveObject {
  name: string;
  value: number;
}

interface ImproveProps {
  content?: ImproveObject[];
  selected: number[];
  handleSelect: (val: number[]) => void;
}

const ImproveContent = (props: ImproveProps): ReactElement => {
  const { content, selected, handleSelect } = props;

  const handleChange = e => {
    const item = Number(e.target.value);
    const items = selected;
    const index = items.indexOf(item);
    index === -1 ? items.push(item) : items.splice(index, 1);
    handleSelect([...items]);
  };

  return (
    <div className={style.wrap}>
      {Array.isArray(content) &&
        content.length > 0 &&
        content.map(item => {
          return (
            <label
              key={item.value}
              className={`${
                selected.indexOf(item.value) !== -1 ? style.active : ''
              } ${style.checkBox}`}
            >
              <input
                className={style.input}
                type="checkbox"
                name={item.name}
                value={item.value}
                onChange={handleChange}
              />
              {item.name}
            </label>
          );
        })}
    </div>
  );
};

export default React.memo(ImproveContent);
